<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb
      id="breadcrumb-container"
      class="breadcrumb-container"
    />
    <div class="right-menu">
      <div
        v-if="userInfo && userInfo.isSingleRole"
        style="
          font-size: 14px;
          color: #333;
          display: inline-block;
          height: 100%;
          line-height: 50px;
          vertical-align: text-bottom;
          margin-right: -10px;
          font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
            Microsoft YaHei, Arial, sans-serif;
        "
      >
        当前角色：
      </div>
      <el-dropdown
        v-if="userInfo && userInfo.isSingleRole"
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
        style="margin-right: 0"
      >
        <div class="avatar-wrapper">
          <!-- <img v-if="userInfo" :src="userInfo.txUrl" class="user-avatar" /> -->
          <span v-if="userInfo.roles">{{ userInfo.roles[0].roleName }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in userInfo.sysUser.roles"
            :key="item.id"
            @click.native="checkRole(item.id)"
          >
            {{ item.roleName }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span
        v-if="userInfo && userInfo.isSingleRole"
        style="
          color: #ccc;
          margin: 0 4px;
          display: inline-block;
          height: 100%;
          line-height: 50px;
          vertical-align: text-bottom;
        "
      >丨</span>
      <template v-if="device !== 'mobile'">
        <search
          id="header-search"
          class="right-menu-item"
        />

        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull
          id="screenfull"
          class="right-menu-item hover-effect"
        />
      </template>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <!-- <img v-if="userInfo" :src="userInfo.txUrl" class="user-avatar" /> -->
          <span v-if="userInfo.sysUser">{{
            userInfo ? userInfo.sysUser.fullName : ""
          }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/subject/index">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <el-dropdown-item
            divided
            @click.native="logout"
          >
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div
      class="right-menu"
      style="
        width: 50%;
        color: #fff;
        margin-right: 50px;
        white-space: nowrap;
        overflow: hidden;
      "
    >
      {{ gly }}
    </div>
  </div>
</template>

<script>
import { chooseRole } from "@/api";
import { mapGetters, mapState } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import Screenfull from "@/components/Screenfull";
import Search from "@/components/HeaderSearch";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    Search,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device"]),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    this.getData();
  },
  data() {
    return {
      gly: "",
      interval: null,
    };
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    setInv() {
      this.interval = setInterval(() => {
        //获取第一个字符
        var start = this.gly.substring(0, 1);
        //得到后面的字符
        var end = this.gly.substring(1);
        //重新赋值
        this.gly = end + start;
      }, 250);
    },
    getData() {},
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    checkRole(id) {
      chooseRole({ roleId: id }).then(() => {
        this.$loading({
          lock: true,
          spinner: "el-icon-loading",
        });
        sessionStorage.removeItem("menuList");
        sessionStorage.removeItem("permissions");
        this.$router.replace("/");
        location.reload();
      });
    },
    logout() {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
      });
      this.$store.dispatch("user/logout").then(() => {
        // CAS退出
        this.$router.replace("/login");
        loading.close();
        location.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        //margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        span {
          padding: 0 5px;
          font-size: 14px;
          color: #333;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          //position: absolute;
          //right: -20px;
          //top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

.el-dropdown-menu {
  min-width: 92px !important;
}
</style>
